import "../assets/link.scss";

/**
 * Компонент ссылки, которая при нажатии будет открываться в программе,
 * работающей с номерами телефонов.
 * 
 * @param {*} props 
 * @returns 
 */
export function LinkPhone(props) {
  const {to, children = []} = props;
  return <a href={`tel:${to}`} className={'link'}>{children}</a>;
}